export const clientKey = 'live_gck_PBal2vxj811eD55579Ee85RQgOAN'; 
export const variantKey = 'amazingpay_masan'; 
